import { isIe } from '../utils/is-ms';
import cssVars from 'css-vars-ponyfill';

if (isIe()) {
	cssVars();
}
